import { CircularProgress, Link, LinkProps } from '@material-ui/core';
import React from 'react';

type Props = LinkProps & {
  isLoading?: boolean;
};
export const LinkLoading = ({
  onClick,
  isLoading = false,
  children,
}: Props) => {
  const renderProgress = isLoading && (
    <CircularProgress
      style={{ marginLeft: '8px', marginTop: '4px' }}
      size={14}
    />
  );

  return (
    <div style={{ display: 'flex' }}>
      <Link style={{ cursor: 'pointer' }} variant="body1" onClick={onClick}>
        {children}
      </Link>

      {renderProgress}
    </div>
  );
};
